import { render, staticRenderFns } from "./NestDetail.vue?vue&type=template&id=4bf2bafe"
import script from "./NestDetail.vue?vue&type=script&lang=js"
export * from "./NestDetail.vue?vue&type=script&lang=js"
import style0 from "./NestDetail.vue?vue&type=style&index=0&id=4bf2bafe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports